export default __webpack_public_path__ + "static/media/numbersearch_locked_crown.a9ca1ad7.svg";